import React from "react";
import styles from "./Container.module.css";

const Content = ({ children,display }) => {
  return <div className={styles.mainContent} style={{display:display}}>{children}</div>;
};

export default Content;
